<div class="session-slots" *ngIf="intialized">
    <ng-container *ngFor="let slot of SessionSlots; index as i">
        <div class="session-slot">
            <input [disabled]="slot.disabled || slot.disabledOverlaped" class="session-slot__checkbox" [id]="'session_'+i+'_'+slot.Start"
                type="checkbox" [(ngModel)]="SessionSlots[i].checked" (change)="onSlotClick(SessionSlots[i])" />
            <label [attr.for]="'session_'+i+'_'+slot.Start" class="session-slot__btn"
                [ngStyle]="{'border-color':slot.color, 'color': slot.color}">
                <div *ngIf="!slot.SessionGroupId" class="session-slot__session-name"
                    title="{{'Session' | translate}} {{i+1}}">{{'session' | translate}} {{i+1}}</div>
                <div *ngIf="slot.SessionGroupId" class="session-slot__session-name" [title]="slot.SessionGroupName">
                    {{slot.SessionGroupName}}</div>
                <span *ngIf="!slot.SessionGroupId">{{slot.Start | localizeDate: 'LT'}} - {{slot.End | localizeDate: 'LT'}}</span>
            </label>

        </div>
    </ng-container>
</div>